import { PageDto } from "./PageDto";
import { PageResponseDto } from "./PageResponseDto";

export class PageMeta {
  static next<T>({
    data,
    meta: { page, count, hasNext },
  }: PageResponseDto<T[]>): PageResponseDto<T[]> {
    return {
      data,
      meta: {
        count,
        page: page + 1,
        hasNext: data.length >= count,
      },
    };
  }

  static create(arg: PageDto = { count: 20, page: 0 }) {
    return arg;
  }
}
